import { ScrollArea } from '../../components/ui/scroll-area';
import React from 'react';
import Footer from './Footer';
import VERSIONS from '@/assets/js/versions';

const APP_VERSION = VERSIONS[process.env.REACT_APP_VERSION];

function Return({ isStandalone }) {
  return (
    <ScrollArea className={`${isStandalone ? 'h-screen' : 'h-full'}`}>
      <div className="p-2 md:container py-10 w-full">
        <h1 className="text-5xl md:text-9xl font-bold md:-ml-2">Refund & Cancellation Policy</h1>
        <p className="text-sm pb-4 font-bold py-4">Last updated: July 26, 2025</p>
        <p className="py-4">
          Thank you for subscribing to our platform. We hope you are happy with your purchase. However, if you are not
          completely satisfied, you may be eligible for a refund under the terms below. Please see below for more
          information on our policy.
        </p>

        <div className="py-4">
          <strong className="text-3xl font-bold">REFUND ELIGIBILITY</strong>
        </div>
        <p className="py-4">
          To be eligible for a refund, you must submit your request within fourteen (14) days of your original purchase
          date. Requests made after this period will not be eligible for a refund.
        </p>

        <div className="py-4">
          <strong className="text-3xl font-bold">HOW TO REQUEST A REFUND</strong>
        </div>
        <p className="py-4">
          To request a refund, please email our customer service team. Your request must be sent from the email address
          associated with your account and include your order number or proof of purchase.
        </p>
        <p className="py-4">Please send your refund request to:</p>
        <p className="text-md font-semibold">{APP_VERSION.email}</p>

        <div className="py-4">
          <strong className="text-3xl font-bold">REFUND PROCESSING</strong>
        </div>
        <p className="py-4">
          After receiving your request, we will review it and notify you via email of the approval or rejection of your
          refund. If your request is approved, we will process your refund, and a credit will automatically be applied
          to your original method of payment. Please allow at least seven (7) business days for us to process your
          refund. It may take an additional 5-10 business days for the refund to post to your account, depending on your
          bank or card issuer.
        </p>

        <div className="py-4">
          <strong className="text-3xl font-bold">SUBSCRIPTION CANCELLATION</strong>
        </div>
        <p className="py-4">
          You can cancel your subscription at any time through your account settings page. Cancelling your subscription
          will prevent future billing, and you will retain access to the platform until the end of your current paid
          billing period. Please note that cancelling a subscription does not automatically trigger a refund for past
          payments.
        </p>

        <div className="py-4">
          <strong className="text-3xl font-bold">NON-REFUNDABLE SITUATIONS</strong>
        </div>
        <ul className="list-disc list-inside py-4 space-y-2">
          <li>Subscription renewals are not eligible for a refund.</li>
          <li>
            Refunds will not be issued for subscriptions that have been cancelled after the 14-day eligibility period.
          </li>
          <li>Promotional or discounted subscriptions are considered FINAL SALE and are not eligible for refunds.</li>
        </ul>

        <div className="py-4">
          <strong className="text-3xl font-bold">QUESTIONS</strong>
        </div>
        <p className="py-4">If you have any questions concerning our refund policy, please contact us at:</p>
        <p className="text-md font-semibold">{APP_VERSION.email}</p>
      </div>
      <Footer />
    </ScrollArea>
  );
}

export default Return;
